// Path: ./src/app/pages/CreateFlyerItemPage/CreateFlyerModal/handleSaveFlyerItem.ts
import { UpdateGfFlyerItemDto } from "@swagger/typescript-fetch-goflyer";
import i18n from "i18next";
import { useLoading } from "../../../../contextApi/LoadingContext";
import { toastError, toastSuccess } from "../../../../utils/pageUtil/toast";
import { messages } from "../../../../locales/messages";
import { adminApiService } from "../../../../utils/api";
import { getShowAt } from "../../../../utils/getShowAt";
import { useContext, useCallback } from "react";
import { GoFlyerAdminContext } from "../../../../contextApi/context";
import { formatRegularPriceString } from "../../../../utils/utils";
import { useUnits } from "../../../../hooks/useUnits";
import { useAuthHeaders } from "../../../../hooks/useAuthHeaders";
import { useGfImage } from "../../../../hooks/useGfImage";
import decideAltUpdate from "../../../../utils/altTextUtil";

export const useHandleSaveFlyerItem = () => {
  const { state } = useContext(GoFlyerAdminContext);
  const { showLoadingScreen } = useLoading();
  const { unitsList, fetchUnits } = useUnits(false);
  const authHeaders = useAuthHeaders();
  const { updateImage } = useGfImage();

  const handleSaveFlyerItem = async (
    storeWebsite: boolean,
    goFlyerWebsite: boolean,
    updateFlyerItem?: UpdateGfFlyerItemDto
  ) => {
    if (!updateFlyerItem?.name) {
      toastError(`${i18n.t(messages.name())} ${i18n.t(messages.is_Empty())}`);
      return;
    }

    if (
      updateFlyerItem?.salePrice === undefined ||
      updateFlyerItem?.salePrice === null ||
      updateFlyerItem?.salePrice < 0
    ) {
      toastError(
        `${i18n.t(messages.Sale_Price())} ${i18n.t(messages.is_Empty())}`
      );
      return;
    }
    // if (!updateFlyerItem?.regularPrice) {
    //   toastError(
    //     `${i18n.t(messages.Regular_Price())} ${i18n.t(messages.is_Empty())}`
    //   );
    //   return;
    // }
    if (!updateFlyerItem?.unit && !updateFlyerItem?.unitV2) {
      toastError(`${i18n.t(messages.Unit())} ${i18n.t(messages.is_Empty())}`);
      return;
    }

    if (updateFlyerItem?.unit && !updateFlyerItem?.unitV2) {
      let localUnits = unitsList;
      if (!localUnits || localUnits.length === 0) {
        localUnits = await fetchUnits();
      }
      if (localUnits && localUnits.length) {
        updateFlyerItem.unitV2 = localUnits.find(
          (val) => val.name === updateFlyerItem.unit
        );
      }
    }

    // if (
    //   !updateFlyerItem?.promotionTag ||
    //   updateFlyerItem.promotionTag.length === 0
    // ) {
    //   toastError(
    //     `${i18n.t(messages.promotionTag())} ${i18n.t(messages.is_Empty())}`
    //   );
    //   return;
    // }
    if (
      !updateFlyerItem?.gfFlyerItemCategory ||
      updateFlyerItem?.gfFlyerItemCategory.length === 0
    ) {
      toastError(
        `${i18n.t(messages.Category())} ${i18n.t(messages.is_Empty())}`
      );
      return;
    }
    if (
      !updateFlyerItem?.gfMultiImages ||
      updateFlyerItem?.gfMultiImages.length === 0
    ) {
      toastError(
        `${i18n.t(messages.Product_Images())} ${i18n.t(messages.is_Empty())}`
      );
      return;
    }

    if (
      !updateFlyerItem?.flyerItemList ||
      !updateFlyerItem?.flyerItemList?.id
    ) {
      toastError(
        `${i18n.t(messages.Flyers_Item_List())} ${i18n.t(messages.is_Empty())}`
      );
      return;
    }

    if (!state.gfAdminUser) {
      toastError(
        `${i18n.t(messages.There_is_an_error_please_Contact_Administrator())}`
      );
      return;
    }
    showLoadingScreen(true);
    if (updateFlyerItem?.gfMultiImages?.length) {
      const nameEn = updateFlyerItem?.name;
      const nameZh = updateFlyerItem?.nameChinese;
      for (let i = 0; i < updateFlyerItem.gfMultiImages.length; i++) {
        const image = updateFlyerItem.gfMultiImages[i];
        const { shouldUpdate, newAlt } = decideAltUpdate(
          image?.gfImage?.alt,
          nameEn,
          nameZh
        );

        console.log("shouldUpdate", shouldUpdate);
        console.log("shouldUpdate newAlt", newAlt);

        if (!shouldUpdate) continue; // skip updating gfImage when not necessary

        try {
          await updateImage({
            id: image.gfImage.id,
            alt: newAlt,
          });
        } catch (e) {
          console.error("Error uploading image:", e);
        }
      }
    }
    const flyerItemResponse = updateFlyerItem.id
      ? await adminApiService.updateOneBaseGfFlyerItemAdminControllerGfFlyerItem(
          {
            ...updateFlyerItem,
            showAt: getShowAt(storeWebsite, goFlyerWebsite),
            regularPriceString:
              updateFlyerItem?.regularPriceString &&
              formatRegularPriceString(updateFlyerItem.regularPriceString),
          },
          updateFlyerItem.id,
          authHeaders
        )
      : await adminApiService.createOneBaseGfFlyerItemAdminControllerGfFlyerItem(
          {
            ...updateFlyerItem, //This is for optional properties
            name: updateFlyerItem.name,
            nameChinese: updateFlyerItem.nameChinese,
            nameFrench: updateFlyerItem.nameFrench,
            salePrice: updateFlyerItem.salePrice,
            regularPriceString:
              updateFlyerItem?.regularPriceString &&
              formatRegularPriceString(updateFlyerItem.regularPriceString),

            unit: updateFlyerItem.unit,
            unitV2: updateFlyerItem.unitV2!,
            promotionTag: updateFlyerItem?.promotionTag,
            gfFlyerItemCategory: updateFlyerItem.gfFlyerItemCategory,
            gfMultiImages: updateFlyerItem.gfMultiImages,
            limitString: updateFlyerItem.limitString,
            priceRemarks: updateFlyerItem.priceRemarks,
            topSale: updateFlyerItem.topSale,
            showAt: getShowAt(storeWebsite, goFlyerWebsite),
            adminUser: state.gfAdminUser,
            flyerItemList: updateFlyerItem.flyerItemList,
          },
          authHeaders
        );
    showLoadingScreen(false);
    toastSuccess(
      `${i18n.t(messages.Flyer_Successfully())} ${
        updateFlyerItem.id
          ? i18n.t(messages.Upload())
          : i18n.t(messages.Created())
      }`
    );
    return flyerItemResponse;
  };
  
  return useCallback(handleSaveFlyerItem, [
    state.gfAdminUser,
    showLoadingScreen,
    unitsList,
    fetchUnits,
    authHeaders,
    updateImage,
  ]);
};
